<h2 mat-dialog-title>
  {{ data.dialogTextPaths.title | translate }}
</h2>
<mat-dialog-content class="requirements-content">
  <ng-container *ngIf="affectedProducts?.length > 0">
    <ng-container
      *ngTemplateOutlet="
        productsList;
        context: {
          description: data.dialogTextPaths.description,
          products: affectedProducts
        }
      "
    ></ng-container>
  </ng-container>
  <ng-container *ngIf="otherAffectedProducts?.length > 0">
    <ng-container
      *ngTemplateOutlet="
        productsList;
        context: {
          description: data.dialogTextPaths.otherDescription,
          products: otherAffectedProducts
        }
      "
    ></ng-container>
  </ng-container>
  <ng-template #productsList let-description="description" let-products="products">
    <span>
      {{ description | translate: { productName: targetProduct.name } }}
    </span>
    <div class="products-list">
      <ng-container *ngFor="let product of products; let last = last">
        <div class="product-wrapper">
          <div class="product-header">
            <va-icon [iconName]="product.name" [iconUrl]="product.icon" [diameter]="32"></va-icon>
            <span class="product-name">{{ product.name }}</span>
          </div>
          <div class="product-price">
            <div [ngClass]="{ 'once-frequency': product.frequency === GalaxyFrequency.ONE_TIME }">
              <billing-ui-simple-price-display
                [price]="product.price"
                [currencyCode]="product.currency"
                [frequency]="product.frequency"
                [topLabel]="product.isStartingAt ? 'starting-at' : ''"
              ></billing-ui-simple-price-display>
            </div>
          </div>
        </div>
        <mat-divider class="product-divider" *ngIf="!last"></mat-divider>
      </ng-container>
    </div>
  </ng-template>
  <span>
    {{ data.dialogTextPaths.confirmation | translate: { productName: targetProduct.name } }}
  </span>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button [mat-dialog-close]="false">
    {{ 'LIB_ORDERS.COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="confirm()" data-action="product-requirements-confirm-button">
    <span>
      {{ data.dialogTextPaths.confirmButton | translate }}
    </span>
  </button>
</mat-dialog-actions>
